import { createFileRoute } from "@tanstack/react-router";
import { PaymentCalendarPage } from "@/features/payment-calendar/payment-calendar-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/dokumenty/kalendarz-platnosci")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.dokumenty.kalendarz-platnosci",
			location.pathname,
		);
	},
	component: PaymentCalendarPage,
});
